export var StudyMapRead;
(function (StudyMapRead) {
    let status;
    (function (status) {
        status["DRAFT"] = "draft";
        status["IN_PROGRESS"] = "in_progress";
        status["VALIDATED"] = "validated";
        status["CANCELED"] = "canceled";
        status["COMPLETED"] = "completed";
    })(status = StudyMapRead.status || (StudyMapRead.status = {}));
})(StudyMapRead || (StudyMapRead = {}));
